const styles = () => ({
  dialogTitle: {
    marginBottom: '0px',
    '$ :after': {
      background: 'none',
    },
  },
  innerModalAccept: {
    position: 'relative',
    '& $crossIconimg': {
      position: 'absolute',
      right: '0px',
      top: '0px',
    },
    '& h1': {
      marginBottom: '16px',
      fontSize: '18px',
      fontWeight: '600',
      color: '#0D2A3A',
    },
    '& h2': {
      marginBottom: '16px',
      color: '#130F26',
      fontSize: '14px',
      fontWeight: '500',
    },
    '& hr': {
      backgroundColor: '#CED1D6',
    },
  },
  yes: { width: '-webkit-fill-available' },
  no: { width: '-webkit-fill-available' },
  '@media (min-width: 768px)': {
    Title: {
      fontSize: '24px',
    },
    subTitle: {
      fontSize: '18px',
    },
  },
  modalBtnholder: {
    textAlign: 'left',
    padding: '8px 0 0',
    display: 'flex',
    '& button': {
      margin: '5px',
      border: '1px solid #0D2A3A',
      padding: ' 16px',
      borderRadius: '0px !important',
    },
    '& $yes': {
      background: '#0088FF',
      color: '#fff',
      border: '1px solid #0088FF',
      padding: ' 16px',
    },
  },
  crossIconimg: {
    float: 'right',
    cursor: 'pointer',
  },
});

export default styles;
